"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let JobHeader = class JobHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    messages;
    ux;
    b_1382594685840889_style;
    dataMembers = ['messages', 'ux', 'b_1382594685840889_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    title: this.$fn.pgettext("Job|ModalHeader", "Job"),
                },
                ux: null,
                b_1382594685840889_style: {
                    maxWidth: "80px",
                },
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.$fn.pgettext("Job|ModalHeader", "Job");
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return '#' + this.item.number;
        }
        return null;
    }
    async act_2754826507016131_emit_7738_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_2754826507016131_clickPreventStop(event, scope) {
        return await this.actions.evh_2754826507016131_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7463771596263925_emit_7742_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_7463771596263925_request_7740_getActionArgs($event) {
        return {
            url: this.item.links.retry,
            method: "PATCH",
            headers: {
                "If-Match": this.item.etag,
            },
        };
    }
    async evh_7463771596263925_clickPreventStop(event, scope) {
        return await this.actions.evh_7463771596263925_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7763705103899431_emit_7746_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_7763705103899431_request_7744_getActionArgs($event) {
        return {
            url: this.item.links.cancel,
            method: "PATCH",
            headers: {
                "If-Match": this.item.etag,
            },
        };
    }
    async evh_7763705103899431_clickPreventStop(event, scope) {
        return await this.actions.evh_7763705103899431_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_2754826507016131_emit_7738 = new core_1.actions.EmitAction({
            actionArgs: this.act_2754826507016131_emit_7738_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_2754826507016131_clickPreventStop_7737 = new core_1.actions.EventHandlerImpl({
            action: act_2754826507016131_emit_7738,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_2754826507016131_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2754826507016131_clickPreventStop_7737],
        });
        const act_7463771596263925_emit_7742 = new core_1.actions.EmitAction({
            actionArgs: this.act_7463771596263925_emit_7742_getActionArgs,
            events: [],
        });
        const evh_7463771596263925_success_7741 = new core_1.actions.EventHandlerImpl({
            action: act_7463771596263925_emit_7742,
            event: "success",
            displayName: "emit",
        });
        const act_7463771596263925_request_7740 = new core_1.actions.RequestAction({
            actionArgs: this.act_7463771596263925_request_7740_getActionArgs,
            displayName: "retryJob",
            events: [evh_7463771596263925_success_7741],
        });
        const evh_7463771596263925_clickPreventStop_7739 = new core_1.actions.EventHandlerImpl({
            action: act_7463771596263925_request_7740,
            event: "click.prevent.stop",
            displayName: "retryJob",
        });
        const evh_7463771596263925_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7463771596263925_clickPreventStop_7739],
        });
        const act_7763705103899431_emit_7746 = new core_1.actions.EmitAction({
            actionArgs: this.act_7763705103899431_emit_7746_getActionArgs,
            events: [],
        });
        const evh_7763705103899431_success_7745 = new core_1.actions.EventHandlerImpl({
            action: act_7763705103899431_emit_7746,
            event: "success",
            displayName: "emit",
        });
        const act_7763705103899431_request_7744 = new core_1.actions.RequestAction({
            actionArgs: this.act_7763705103899431_request_7744_getActionArgs,
            displayName: "cancelJob",
            events: [evh_7763705103899431_success_7745],
        });
        const evh_7763705103899431_clickPreventStop_7743 = new core_1.actions.EventHandlerImpl({
            action: act_7763705103899431_request_7744,
            event: "click.prevent.stop",
            displayName: "cancelJob",
        });
        const evh_7763705103899431_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7763705103899431_clickPreventStop_7743],
        });
        return {
            act_2754826507016131_emit_7738,
            evh_2754826507016131_clickPreventStop_7737,
            evh_2754826507016131_clickPreventStop,
            act_7463771596263925_emit_7742,
            evh_7463771596263925_success_7741,
            act_7463771596263925_request_7740,
            evh_7463771596263925_clickPreventStop_7739,
            evh_7463771596263925_clickPreventStop,
            act_7763705103899431_emit_7746,
            evh_7763705103899431_success_7745,
            act_7763705103899431_request_7744,
            evh_7763705103899431_clickPreventStop_7743,
            evh_7763705103899431_clickPreventStop,
            reload: act_2754826507016131_emit_7738,
            retryJob: act_7463771596263925_request_7740,
            cancelJob: act_7763705103899431_request_7744,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], JobHeader.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHeader.prototype, "onItem", null);
JobHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], JobHeader);
exports.default = JobHeader;
vue_property_decorator_1.Vue.component("JobHeader", JobHeader);
